import type { Conversation } from 'lib-shared-types-api';

import { toBoolean } from 'utils/formatting/string';
import { AppSearchParams } from 'utils/url/useAppSearchParams';

/**
 * Checks whether a conversation matches the conversations search params.
 *
 * @param conversation The conversation.
 * @param params The conversations search params.
 */
export function conversationMatchesSearchParams(
  conversation: Conversation,
  params: AppSearchParams<'/conversations'>,
): boolean {
  // Assignment mismatch
  // Assigned and agent params are mutually exclusive.
  if (params.assigned && params.agent) {
    return false;
  }

  if (
    params.assigned &&
    ((conversation.assignment && !toBoolean(params.assigned)) ||
      (!conversation.assignment && toBoolean(params.assigned)))
  ) {
    return false;
  }

  if (
    params.agent &&
    conversation.assignment &&
    !params.agent.includes(conversation.assignment.agent_id)
  ) {
    return false;
  }

  if (params.agent && !conversation.assignment) {
    return false;
  }

  // Status mismatch
  if (params.status && !params.status.includes(conversation.status)) {
    return false;
  }

  // Direction mismatch
  if (params.direction && !params.direction.includes(conversation.direction)) {
    return false;
  }

  // Channel mismatch
  if (
    params.channel &&
    !params.channel.includes(conversation.initial_channel)
  ) {
    return false;
  }

  // Queue mismatch
  if (
    params.queue &&
    ((!conversation.queue && !params.queue.includes('')) ||
      (conversation.queue && !params.queue.includes(conversation.queue.id)))
  ) {
    return false;
  }

  // Requester mismatch
  if (
    params.requester &&
    (!conversation.requested_by ||
      (conversation.requested_by &&
        !params.requester.includes(conversation.requested_by)))
  ) {
    return false;
  }

  return true;
}
